module.exports = __webpack_public_path__ + "img/Avatar-75.140ef443.svg";